import { createSlice } from "@reduxjs/toolkit";
import { FireBaseTypes } from "utils/types";

export interface firebaseSliceTypes {
  firebaseDetails: FireBaseTypes;
  activityLogs: any;
  logsLoader: boolean;
}
// initial state
const initialState: firebaseSliceTypes = {
  firebaseDetails: {
    ticker: {
      textColor: "#000000",
      bodyColor: "#FFA500",
      message: "",
      businessId: "",
      visibility: false,
    },
    clarity: {
      status: false,
      projectId: "",
    },
    auth: {
      login: "",
      signup: "",
    },
  },
  activityLogs: [],
  logsLoader: true,
};

const FireBaseDetailsSlice = createSlice({
  name: "firebaseDetails",
  initialState,
  reducers: {
    setFireBaseDetails(state, action) {
      state.firebaseDetails = action.payload;
    },
    resetFireBaseDetails(state) {
      state.firebaseDetails.ticker = {
        textColor: "#000000",
        bodyColor: "#FFA500",
        message: "",
        businessId: "",
        visibility: false,
      };
      state.firebaseDetails.auth = {
        login: "",
        signup: "",
      };
    },
    setActivityLogs(state, action) {
      state.activityLogs = action.payload;
      state.logsLoader = false;
    },
  },
});

export default FireBaseDetailsSlice.reducer;

export const { setFireBaseDetails, resetFireBaseDetails, setActivityLogs } =
  FireBaseDetailsSlice.actions;
